export type DateValue = Date | string | number;

const pad2 = (value: number) => String(value).padStart(2, '0');

const parseDate = (value: DateValue) => {
  if (value instanceof Date) return value;

  // Date-only API values represent calendar dates. Parsing YYYY-MM-DD with
  // Date would treat them as UTC and can display the previous local day.
  if (typeof value === 'string') {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
    if (match) return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  }

  return new Date(value);
};

export const formatDate = (value?: DateValue | null, fallback = '—') => {
  if (value === undefined || value === null || value === '') return fallback;
  const date = parseDate(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}/${date.getFullYear()}`;
};

export const formatDateTime = (value?: DateValue | null, fallback = '—') => {
  if (value === undefined || value === null || value === '') return fallback;
  const date = parseDate(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return `${formatDate(date, fallback)} ${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
};
